/*****************************************************************************************
 * 설명 : 관리자 > 컨텐츠관리 > 컨텐츠관리
 * URI : /admin/cms/menuList
*****************************************************************************************/
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import SplitPane from 'react-split-pane';
import * as Yup from "yup";

import { Restful } from 'service/restful';
import { getSelectData } from 'service/utils';

import { ButtonEx, SelectEx } from 'components/inputEx';

import Layout from 'pages/admin/layout/layout';
import TabBoardList from './tabBoardList';
import TabBoardWrite from './tabBoardWrite';
import TabContents from './tabContents';
import TabContentsLog from './tabContentsLog';
import TabMenuConfig from './tabMenuConfig';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const MenuList = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const currentMenu = useSelector(state => state?.menuList?.current);

  const [tabIndex, setTabIndex] = useState(0);
  const [boardFunc, setBoardFunc] = useState('list');

  const [selectedNode, setSelectedNode] = useState({});

  const [siteList, setSiteList] = useState([]);
  const [menuList, setMenuList] = useState([]);

  const [boardData, setBoardData] = useState([]);

  /*
  const [state, setState] = useState([
    { id: 1, title: 'Chicken', children: [{ id: 11, title: 'Egg' }] },
    { id: 2, title: 'Fish', children: [{ id: 21, title: 'fingerline' }] },
  ]);
  */

  const formik = useFormik({
    initialValues: {
      siteSeq: '',
    },
    validationSchema: Yup.object().shape({
    }),
    onSubmit: (values) => {
    }
  });

  /***************************************************************************************
   * 설명 : 사이트 리스트 가져오기
  ***************************************************************************************/
  const getSiteInfo = () => {
    let params = {
      program: 'api',
      service: 'cms',
      action: 'getSiteInfo',
      version: '1.0'
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result ) {
        setSiteList(getSelectData(response.data.siteInfo, 'siteName', 'seq'));
      } else {
        setSiteList([]);
      }
    })
  }

  /***************************************************************************************
   * 설명 : 메뉴 리스트 가져오기
  ***************************************************************************************/
  const getMenuList = (siteSeq) => {
    let params = {
      program: 'api',
      service: 'cms',
      action: 'getMenuList',
      version: '1.0',
      seq: siteSeq
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result && response.data.data && response.data.data.length > 0 ) {
        setMenuList([
          ...response.data.data.map((item) => {
            return {
              id: parseInt(item.id ?? 0),
              children: item.children ?? [],
              title: item.title,
              boardId: item.boardId,
              contents: item.contents,
              createDate: item.createDate,
              creator: item.creator,
              groupId: item.groupId,
              icon: item.icon,
              isDel: item.isDel,
              isLinkOpen: item.isLinkOpen,
              isLogin: parseInt(item.isLogin ?? 0),
              isMainmenuView: parseInt(item.isMainmenuView ?? 0),
              isMenuView: parseInt(item.isMenuView ?? 0),
              isRouter: parseInt(item.isRouter ?? 0),
              isUse: parseInt(item.isUse ?? 0),
              linkUrl: item.linkUrl ?? '',
              moduleSeq: parseInt(item.moduleSeq ?? 0),
              pageCode: item.pageCode,
              pageMenuName: item.pageMenuName,
              pageName: item.pageName,
              queryString: item.queryString,
              seq: parseInt(item.seq ?? 0),
              siteSeq: parseInt(item.siteSeq ?? 0),
              updateDate: item.updateDate,
              updater: item.updater,
              module: item.module,
              moduleName: item.moduleName,
              modulePath: item.modulePath
            }
          })
        ]);

      } else {
        setMenuList([]);
      }

      setSelectedNode({});
    })
  }

  /***************************************************************************************
   * 설명 : 사이트 변경 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( formik.values.siteSeq !== '' ) {
      getMenuList(formik.values.siteSeq);
    }

    // eslint-disable-next-line
  }, [formik.values.siteSeq]);

  /***************************************************************************************
   * 설명 : 데이터 처리
  ***************************************************************************************/
  useEffect(() => {
    getSiteInfo();

    // eslint-disable-next-line
  }, [window.location.search]);

/***************************************************************************************
   * 설명 : 데이터 처리
  ***************************************************************************************/
  useEffect(() => {
    setBoardFunc('list');

    // eslint-disable-next-line
  }, [selectedNode]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <Layout>
      <section className="admin-cms-contents">
        <SplitPane split="vertical" minSize={25} defaultSize={400}>
          <div className="mr10">
            <header className="admin-cms-search-header">
              <div>
                <SelectEx
                  name="siteSeq"
                  formik={formik}
                  fullWidth={true}
                  style={{width: '200px'}}
                  data={[
                    {label: '사이트 선택', value: ''}
                  ].concat(siteList)}
                />
              </div>
              <div className="right">
                <ButtonEx
                  title="메뉴등록"
                  auth="authWrite"
                  color="primary"
                  className="ml5"
                  variant="contained"
                  disabled={formik.values.siteSeq === ''}
                  onClick={() => {
                    setTabIndex(0);

                    let node = {...selectedNode};
                    node.seq = 0;
                    node.siteSeq = formik.values.siteSeq;
                    setSelectedNode(node);
                  }}
                />
              </div>
            </header>

            <section className="admin-cms-body" style={{border: 'solid 1px #ccc'}}>
              <div style={{ height: 'calc(100vh - 130px)' }}>
                <SortableTree
                  treeData={menuList}
                  onChange={(treeData) => {
                    setMenuList([...treeData])
                  }}
                  rowHeight={50}
                  isVirtualized={false}
                  generateNodeProps={(rowInfo) => {
                    const { node } = rowInfo;

                    return {
                      onClick: (event) => {
                        if( selectedNode?.id === node.id ) setSelectedNode({seq: ''});
                        else setSelectedNode(node);
                      },
                      className: selectedNode?.id === node.id ? 'tree-selected' : '',
                      style: selectedNode?.id === node.id ? { border: "1px solid #005aff"} : {border: '1px solid #fff'}
                    }
                  }}
                />
              </div>

            </section>
          </div>

          <div className="ml10">
            <section className="">
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={tabIndex} onChange={(event, newValue) => {
                    setTabIndex(newValue);
                  }}>
                    <Tab label="기본정보 설정" />
                    <Tab label="컨텐츠 관리" disabled={selectedNode.seq === 0} />
                    <Tab label="게시판 관리" disabled={selectedNode.seq === 0} />
                    <Tab label="메뉴이력 관리" disabled={selectedNode.seq === 0} />
                  </Tabs>
                </Box>

                {/* 기본정보 설정 */}
                <section hidden={tabIndex !== 0}>
                  <TabMenuConfig
                    tabIndex={tabIndex}
                    data={selectedNode}
                    siteSeq={formik.values.siteSeq}
                    menuList={menuList}
                    setMenuList={setMenuList}
                    getList={() => getMenuList(formik.values.siteSeq)}
                    indicator={props.indicator}
                    history={props.history}
                    currentMenu={currentMenu}
                  />
                </section>

                {/* 컨텐츠 관리 */}
                <section hidden={tabIndex !== 1}>
                  <TabContents
                    tabIndex={tabIndex}
                    data={selectedNode}
                    menuList={menuList}
                    setMenuList={setMenuList}
                    getList={() => getMenuList(formik.values.siteSeq)}
                    siteSeq={formik.values.siteSeq}
                    indicator={props.indicator}
                    history={props.history}
                    currentMenu={currentMenu}
                  />
                </section>

                {/* 게시판 관리 */}
                <section hidden={tabIndex !== 2}>
                  { boardFunc === 'list' &&
                    <TabBoardList
                      tabIndex={tabIndex}
                      setBoardFunc={setBoardFunc}
                      setBoardData={setBoardData}
                      data={selectedNode}
                      siteSeq={formik.values.siteSeq}
                      indicator={props.indicator}
                      history={props.history}
                      currentMenu={currentMenu}
                    />
                  }
                  { boardFunc === 'write' &&
                    <TabBoardWrite
                      tabIndex={tabIndex}
                      setBoardFunc={setBoardFunc}
                      setBoardData={setBoardData}
                      data={selectedNode}
                      boardData={{
                        seq: 0,
                        boardId: selectedNode.boardId,
                        groupid: selectedNode.groupId,
                        data: boardData
                      }}
                      siteSeq={formik.values.siteSeq}
                      indicator={props.indicator}
                      history={props.history}
                      currentMenu={currentMenu}
                    />
                  }
                </section>

                {/* 메뉴이력 관리 */}
                <section hidden={tabIndex !== 3}>
                  <TabContentsLog
                    tabIndex={tabIndex}
                    data={selectedNode}
                    siteSeq={formik.values.siteSeq}
                    indicator={props.indicator}
                    history={props.history}
                    currentMenu={currentMenu}
                  />
                </section>
              </Box>
            </section>
          </div>
        </SplitPane>
      </section>
    </Layout>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default MenuList;